export enum TRUCK_STATE {
  ASSIGNED = 0,
  UNASSIGNED = 1,
  RESERVED = 2,
}
